import React from 'react';
import PropTypes from 'prop-types';
import { CheckNearByStore } from './partials/store/CheckNearByStore';
import { IDS } from '../../automationTestIds';

export const PickupHeader = ({
  storeName,
  itemId,
  quantity,
  originalConfigId,
  lineItemId,
  pickupUnavailable,
  isMajorAppliance,
  isCartTiles,
  localizerStoreName,
  addOnsAssemblyAndMore,
  isExchangeCustomer,
  storeId,
  disablePickupNearBy,
}) => {
  const displayStoreName = isCartTiles ? (storeName || localizerStoreName) : storeName;
  const storeNameComponent = isMajorAppliance || disablePickupNearBy || (isCartTiles && isExchangeCustomer)
    ? displayStoreName
    : (
      <CheckNearByStore
        itemId={itemId}
        quantity={quantity}
        originalConfigId={originalConfigId}
        lineItemId={lineItemId}
        addOnsAssemblyAndMore={addOnsAssemblyAndMore}
        isCartTiles={isCartTiles}
        storeIdFromCart={storeId}
      >
        {displayStoreName}
      </CheckNearByStore>
    );

  return (
    <div
      className="fulfillment__header"
      data-automation-id={pickupUnavailable ? IDS.UA.pickup_unavailable : IDS.LABEL.pickupLabel}
    >
      <span>
        {(pickupUnavailable) ? <span className="u__bold">Unavailable </span> : <span>Pickup</span>}
        {(displayStoreName) && (
          <>
            {' at '}
            {storeNameComponent}
          </>
        )}
      </span>
    </div>
  );
};

PickupHeader.propTypes = {
  storeName: PropTypes.string,
  itemId: PropTypes.string.isRequired,
  pickupUnavailable: PropTypes.bool,
  isMajorAppliance: PropTypes.bool,
  isCartTiles: PropTypes.bool,
  localizerStoreName: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  addOnsAssemblyAndMore: PropTypes.object,
  isExchangeCustomer: PropTypes.bool,
  storeId: PropTypes.string,
  lineItemId: PropTypes.string,
  quantity: PropTypes.number,
  originalConfigId: PropTypes.string,
  disablePickupNearBy: PropTypes.bool,
};

PickupHeader.defaultProps = {
  storeName: '',
  pickupUnavailable: false,
  isMajorAppliance: false,
  isCartTiles: false,
  localizerStoreName: '',
  addOnsAssemblyAndMore: null,
  isExchangeCustomer: false,
  storeId: '',
  lineItemId: '',
  quantity: 1,
  originalConfigId: null,
  disablePickupNearBy: false,
};
